<template>
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.000000 50.000000">
        <g transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
            <path class="color" fill="#F45B5B" d="M230 460 c0 -15 7 -20 25 -20 34 0 94 -26 124 -53 100 -92 68 -258
            -61 -312 -21 -8 -49 -15 -63 -15 -18 0 -25 -5 -25 -20 0 -28 51 -26 115 4 60
            28 87 56 114 116 27 60 26 123 -3 185 -28 60 -56 87 -116 114 -61 28 -110 28
            -110 1z"/>
            <path class="color" fill="#F45B5B" d="M141 451 c-12 -8 -12 -12 -2 -25 16 -20 53 -4 45 19 -7 17 -22 19
            -43 6z"/>
            <path class="color" fill="#F45B5B" d="M70 396 c-10 -13 -10 -19 0 -32 12 -14 15 -14 29 0 14 15 14 17 0 32
            -14 14 -17 14 -29 0z"/>
            <path class="color" fill="#F45B5B" d="M279 279 l-52 -80 -32 31 c-34 33 -50 37 -58 15 -4 -9 13 -31 45 -59
            l52 -45 63 94 c35 52 63 99 63 104 0 5 -6 11 -14 14 -10 4 -32 -21 -67 -74z"/>
            <path class="color" fill="#F45B5B" d="M26 304 c-7 -19 1 -34 19 -34 15 0 28 27 19 41 -9 14 -31 10 -38 -7z"/>
            <path class="color" fill="#F45B5B" d="M26 221 c-9 -14 4 -41 19 -41 18 0 26 15 19 34 -7 17 -29 21 -38 7z"/>
            <path class="color" fill="#F45B5B" d="M70 135 c-11 -13 -11 -19 2 -32 17 -16 38 -10 38 11 0 8 -6 19 -14
            25 -10 9 -16 8 -26 -4z"/>
            <path class="color" fill="#F45B5B" d="M139 74 c-10 -13 -10 -17 2 -25 21 -13 36 -11 43 6 8 23 -29 39 -45
            19z"/>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'OngoingIcon'
}
</script>
